import { HpClientSection, HpCustomSectionTitle, HpHelpInfoUI } from '../../../types';
import { HpCommonGroupControlProps } from '../../../types/inputControlTypes';
import { HelpWidget, InfoWidget, WarningWidget } from '../../widgets/helpInfoWidget';
import { HtmlWidget } from '../../widgets/htmlWidget';
import { getHelpAndInfoText } from '../../widgets/widgetUtilities';

export interface HpSectionGroupControlProps extends HpCommonGroupControlProps {
  section: HpClientSection;
  helpInfoUI: HpHelpInfoUI | undefined;
}

export type HpSectionControlFunction = (props: HpSectionGroupControlProps) => JSX.Element;

export function SectionControl({
  controls,
  helpInfoUI,
  id,
  index,
  label,
  section
}: HpSectionGroupControlProps): JSX.Element {
  const data = getHelpAndInfoText(section.helpInfo, helpInfoUI);
  const { canShowHelp, canShowInfo, canShowWarning, helpText, infoText, warningText } = data;

  let labelText = label;
  const classNames = ['av-card', 'av-card-child', 'hp-section'];
  if (index !== undefined) {
    classNames.push('hp-group', `hp-group-${index}`);
  }

  if (typeof label !== 'string') {
    let classExtra: string | null = null;
    ({ text: labelText, className: classExtra } = label as HpCustomSectionTitle);
    classNames.push('hp-group-collapsible');
    if (classExtra) {
      classNames.push(classExtra);
    }
  }

  return (
    <div id={id} className={classNames.sort().join(' ')}>
      {labelText && <HtmlWidget html={labelText} tagName="h3" />}
      {canShowWarning && <WarningWidget warningText={warningText as string} />}
      {canShowInfo && <InfoWidget infoText={infoText as string} />}
      {canShowHelp && <HelpWidget helpText={helpText as string} />}
      <div>{controls}</div>
    </div>
  );
}
